import React, {useEffect, useState} from "react";
import {ConfigProvider, Table} from "antd";
import {
    TechnicianListingTableHeaders,
    TechnicianListingTableHeadersCancelled,
    TechnicianListingTableHeadersCompleted,
    TechnicianListingTableHeadersPending,
} from "../Constants";
import TechnicianListingFilters from "./TechnicianListingFilters";
import TechnicialListingHeader from "./TechnicialListingHeader";
import {getTechnicianGroupListingByCases} from "../../../Services/technicianGroup";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";
import {useDispatch} from "react-redux";
import {TablePageSizeOptions, WorkforceTablePageSize} from "../../../constant";

const TechnicianListingPage = () => {
    const dispatch = useDispatch();
    const [technicianData, setTechnicianData] = useState([]);
    // we need to set this to a default because of the table headers being dynamic
    const [listingType, setListingType] = useState("completed");
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: WorkforceTablePageSize,
            total: WorkforceTablePageSize + 2,
            showSizeChanger: true,
            pageSizeOptions: TablePageSizeOptions
        },
    });
    const [tableFilters, setTableFilters] = useState({});

    // rowSelection object indicates the need for row selection
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
        },
        getCheckboxProps: (record) => ({
            disabled: record.name === "Disabled User",
            name: record.name,
        }),
    };

    const technicianListingHeaders =
        [{
            listingType: "completed",
            data: [...TechnicianListingTableHeaders, ...TechnicianListingTableHeadersCompleted]
        },
            {listingType: "pending", data: [...TechnicianListingTableHeaders, ...TechnicianListingTableHeadersPending]},
            {
                listingType: "cancelled",
                data: [...TechnicianListingTableHeaders, ...TechnicianListingTableHeadersCancelled]
            }
        ]

    useEffect(() => {
        retrieveTechnicianGroupListingByCases();
    }, []);

    const retrieveTechnicianGroupListingByCases = (data) => {
        dispatch(SET_IS_API_CALLED("Fetching Data"));
        getTechnicianGroupListingByCases({
            ...tableFilters,
            pageSize: data?.pageSize ?? tableParams?.pagination.pageSize,
            pageIndex: data?.current ?? tableParams?.pagination.current,
        })
            .then((res) => {
                setTechnicianData(res?.data?.items.map(item => {
                    return {...item, key: item?.id};
                }));
                setTableParams({
                    pagination: {
                        current: res?.data?.pageIndex,
                        pageSize: data?.pageSize ?? WorkforceTablePageSize,
                        total: res?.data?.totalItems,
                        showSizeChanger: true,
                        pageSizeOptions: TablePageSizeOptions
                    }
                });
            })
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED("Fetching Data"));
            });
    }

    return (
        <>
            <div className="p-4">
                <TechnicialListingHeader tableFilters={tableFilters}/>
                <TechnicianListingFilters setListingType={setListingType} setTechnicianData={setTechnicianData}
                                          technicianData={technicianData} tableParams={tableParams}
                                          setTableParams={setTableParams}
                                          setTableFilters={setTableFilters}
                />
                <ConfigProvider
                    theme={{
                        components: {
                            Table: {
                                headerBg: "#F5F5F5",
                                headerColor: "#2F5E8A",
                                headerSortActiveBg: "#F5F5F5",
                                headerSortHoverBg: "#F5F5F5",
                                fixedHeaderSortActiveBg: "#F5F5F5",
                            },
                        },
                    }}
                >
                    <Table
                        className="table-striped-rows"
                        dataSource={technicianData ?? []}
                        rowSelection={{type: "checkbox", ...rowSelection}}
                        columns={technicianListingHeaders.find(headers => headers.listingType === listingType)?.data}
                        pagination={tableParams?.pagination}
                        onChange={(data) => {
                            setTableParams({
                                pagination: data
                            });
                            retrieveTechnicianGroupListingByCases(data);
                        }}
                    ></Table>
                </ConfigProvider>
            </div>
        </>
    );
};

export default TechnicianListingPage;
